import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Grid,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import {
  DownloadSpecialPriceTableLabWord,
  HasDiscountTableDownloadPermissionApi,
  LabelPrinterCustomerApi,
} from '@/services/api/specialPriceTable';
import { PageOrderRequest } from '@/services/api/PageOrderRequest';
import Notice from '@/components/notice';
import { NoticeRef } from '@/components/notice/types';
import Pdf from './pdf';
import { BaseSize } from '@/styles';
import { PdfDto } from '@/services/api/specialPriceTable/message/LabelPrinterCustomerRequest';
import { generatePdf } from '@/components/pdfTool/pdfA4Script';

const LabelPrinterPdf = () => {
  const currentLocation = useLocation();

  const noticeRef = useRef<NoticeRef>(null);

  const [page, setPage] = useState<PageOrderRequest>({ Limit: 500, Page: 0 });

  const [total, setTotal] = useState(0);

  const [pdfList, setPdfList] = useState<Array<PdfDto>>([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    HasDiscountTableDownloadPermissionApi({}).then(data => {
      if (data === undefined || data?.Data === false || data?.Data === undefined) {
        setLoading(true);
      } else if (data?.Data === true) {
        setLoading(false);
      }
    });
    LabelPrinterCustomerApi({
      SpecialPrickCustomerInformationIdList: currentLocation.state as string[],
      Page: page,
    })
      .then(data => {
        if (data?.Data === undefined || data.Data.length === 0) {
          noticeRef.current?.Show({
            Message: data?.Msg,
            Open: true,
            TypeInfo: 'error',
          });
        }
        setPdfList(data.Data);
        setTotal(data.Total);
      });
  }, []);

  const generatePdfOnClick = async () => {
    await generatePdf('.labelPrinterPdf', () => {
      setLoading(true);
    });
  };

  const generateWordOnClick = async () => {
    DownloadSpecialPriceTableLabWord({
      SpecialPrickCustomerInformationIdList: pdfList.flatMap(pdfDto => pdfDto.PdfItem || [])
        .filter(item => item?.SpecialPrickCustomerInformationId)
        .map(item => item.SpecialPrickCustomerInformationId),
      Page: { Page: 0, Limit: 500 },
    });
  };

  return (
        <Box>
            <Notice ref={noticeRef}/>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    标签预览
                </Grid>
                <Grid item xs={1}>
                    <Button variant="contained" size={BaseSize.size}  disabled={loading}  onClick={() => {
                      generatePdfOnClick();
                    }}>
                        下载PDF
                    </Button>

                </Grid>
                <Grid item xs={1}>
                    <Button variant="contained" size={BaseSize.size}  disabled={loading}  onClick={() => {
                      generateWordOnClick();
                    }}>
                        下载Word
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    &nbsp;
                </Grid>
            </Grid>
            <Grid container spacing={2}  sx={{ overflowY: 'auto', overflowX: 'auto', height: '700px' }}>
                    {
                        pdfList.map((row, index) => {
                          return (
                              <Grid item xs={6} key={'PdfDev' + index}>
                                <Pdf ClassName={'labelPrinterPdf'} key={'pdfDiv' + index} PdfDto={row}
                                     PdfPaperId={'pdfDiv' + index}/>
                              </Grid>
                          );
                        })
                    }
            </Grid>
        </Box>
  );
};

export default LabelPrinterPdf;
